import './honeywell/style';
import FormStructure from './honeywell/form_structure';

export default FormStructure;